import { Pipe, PipeTransform } from '@angular/core';

// This pipe is needed to fix searching in ngbTypeahead directive. Without it,
// the search request gets canceled before we can display suggestions for the
// search term.
// For more details, please check:
// - https://github.com/airbrake/airbrake-ng/issues/5677
// - https://github.com/ng-bootstrap/ng-bootstrap/issues/4055
@Pipe({
  name: 'applyPure',
  pure: true,
})
export class ApplyPurePipe implements PipeTransform {
  public transform(templateValue: any, fnReference: Function, ...fnArguments: any[]): any {
    // Join the inputs from both sides of the function ref.
    fnArguments.unshift(templateValue);

    return fnReference.apply(null, fnArguments);
  }
}
